import { withTranslatedMeta, withRouter } from 'i18n/utils'

import { lastBookingLinkSelector } from 'booking/selectors'
import Button from '@components/Button'

import AddCreditCardModal from './AddCreditCardModal'
import CreditCardList from './CreditCardList'
import './styles.scss'

const CreditCardView = ({ lastBookingLink, history }) => (
    <div className="container credit-cards-container dashboard-inner-container">
        {lastBookingLink && (
            <Button className="mb-4" btnStyle="link" iconLeft="arrow-left" onClick={() => history.goBack()}>
                <T>dashboard.button.back-to-booking</T>
            </Button>
        )}
        <h3 className="mb-4 font-weight-bold">
            <T>dashboard.label.my.cards</T>
        </h3>

        <CreditCardList />
        <AddCreditCardModal />
    </div>
)

const mapStateToProps = createStructuredSelector({
    lastBookingLink: lastBookingLinkSelector,
})

export default compose(
    withRouter,
    withTranslatedMeta('dashboard.label.my.cards'),
    connect(mapStateToProps)
)(CreditCardView)
